<template>
  <div class="flex-valign alarm-list-page" v-loading="dataLoading" element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading" :class="{ closeList: isShowList }">
    <div class="blur-bg map-blur-panel"></div>
    <control-left ref="left" @handleSearch="handleSearch"></control-left>
    <el-scrollbar ref="alarmList" class="ioc-alarm__scrollbar" style="padding-bottom: 10px; margin-top: 52px">
      <div class="noData" v-if="data.length === 0 && !isShowList">
        <div class="text-center" style="margin-bottom: 10px">
          <img src="@/common/assets/images/empty.svg" class="no-data_img" />
        </div>
        {{ $t("realTimeAlarm.title.noData") }}
      </div>
      <ul class="ioc-alarm__list__item">
        <li class="map-blur-panel__list-item" v-for="(item, index) in data" :key="index" @contextmenu.prevent="(e) => {
          rightClick(item, e);
        }
          " :class="[
    checkItem.alarmId == item.alarmId ? 'active' : '',
    alarmColor(item.alarmLevel),
  ]" @click.stop="handleClick(item)">
          <!-- 右击弹窗 -->
          <div v-if="visibleRightId == item.alarmId" class="rightTip" :style="{
            left: tipLeft + 'px',
            top: tipTop + 'px',
          }">
            <el-button @click.stop="alarmMerge(item)" :title="item.alarmMergeFlag == 1 ? '取消合并' : '告警合并'" size="mini"
              type="text">{{
                item.alarmMergeFlag == 1 ? "取消合并" : "告警合并"
              }}</el-button>
            <div style="width: 80%; border: 1px solid rgb(218, 220, 224)"></div>
            <el-button @click.stop="alarmControl(item)" title="告警抑制" size="mini" type="text">告警抑制</el-button>
            <span title="关闭" class="closeTitle" @click.stop="visibleRightId = ''">
              <i class="el-icon-circle-close"></i>
            </span>
          </div>
          <span class="alarm_level">{{
            item.alarmLevel | dic("SENU017")
          }}</span>
          <div class="alarm_name" :title="item.alarmName">
            {{ item.alarmName }}
          </div>
          <span class="alarm_state">
            {{ queryHandleStatus(item.alarmState) }}
          </span>

          <!-- groupName -->
          <div class="alarm_time" v-if="alarmMergeFlag == 0">
            {{ item.alarmTime | moment }}
          </div>
          <!-- 合并弹窗 -->
          <div class="alarm_time" v-else>
            <div class="expand-list" @click.stop="handleLeftClick(item)">
              <div style="font-size: 12px">合并详情</div>
              <el-button type="text" :title="!item.isExpand ? '展开' : '收起'"
                style="margin-left: 10px; font-size: 15px; color: #fff" :class="[
                  'iconfont-lunan icon-lunan-xiaosanjiaodown',
                  item.isExpand ? 'icon-transform' : '',
                ]">
              </el-button>
            </div>
            <el-collapse-transition>
              <div class="list-detail" v-if="item.isExpand">
                <div class="listTitle">
                  <span>总条数:{{ lefTdata.length }}</span>
                </div>
                <el-scrollbar :style="{
                  height:
                    lefTdata.length * 35 + 6 > autoHeight
                      ? autoHeight + 'px'
                      : lefTdata.length * 35 + 6 + 'px',
                }" style="padding: 5px 0">
                  <ul class="listUl" v-infinite-scroll="loadul">
                    <li v-for="(it, id) in lefTdata" :key="id" class="listLi" @click.stop="handleClick(it)">
                      <div class="listLi_time">
                        <i class="el-icon-time"></i>
                        {{ it.alarmTime | moment }}
                      </div>
                      <div class="listLi_level alarm_level">{{
                        it.alarmLevel | dic("SENU017")
                      }}</div>
                    </li>
                  </ul>
                </el-scrollbar>
                <div class="listbt">
                  <el-button size="mini" :disabled="lefTdata.length * 40 < autoHeight || autoHeight == 500
                    ? true
                    : false
                    " @click.stop="checkMore" type="primary">查看更多</el-button>
                  <el-button size="mini" :disabled="!lefTdata.length" @click.stop="dealError(item)"
                    type="primary">误报处理</el-button>
                </div>
              </div>
            </el-collapse-transition>
          </div>
          <div class="alarm_area">
            <!-- item.deviceWorkGroupName ||  -->
            {{ item.groupName }}
          </div>
        </li>
      </ul>
    </el-scrollbar>
    <div :class="[
      'map-blur-panel__expand-button left iconfont-lunan',
      isShowList
        ? 'icon-lunan-shousuocaidan-copy'
        : 'icon-lunan-shousuocaidan',
    ]" @click="isShowList = !isShowList"></div>
    <alarmControl @alarmControl="alarmControlCall" ref="alarmControl"></alarmControl>

    <div class="handle-alarm-button" v-auth="'/realTimeAlarm:add'">
      <el-button type="primary" @click="handleAddAlarm">手动告警</el-button>
    </div>
    <div class="handle-deal-button">
      <el-button type="primary" @click="handleDealShow">一键误报</el-button>
    </div>
    <el-dialog title="一键误报处理" :visible.sync="dealVisible" append-to-body :close-on-click-modal="modalClose" width="56%"
      style="margin-top: 10px;">
      <div>
        <el-form ref="dealForm" :model="dealForm" inline label-width="90px">
          <el-form-item label="时间范围" prop="alarmTime">
            <el-date-picker v-model="dealForm.alarmTime" type="datetimerange" clearable value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始时间" end-placeholder="结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="告警等级" prop="alarmLevel">
            <el-select v-model="dealForm.alarmLevel" placeholder="请选择">
              <el-option v-for="item in alarmLevelArr" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="告警类型" prop="alarmType">
            <el-cascader :title="typeLabel" clearable v-model="dealForm.alarmType" ref="cascaderPanel"
              placeholder="默认全部类型" :show-all-levels="false" :options="cascaderOptions"
              :props="cascaderProps"></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="detailQuery">查询</el-button>
            <el-button size="small" @click="detailReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="max-height: 480px; overflow-y: auto;">
        <el-table :data="dealAlarmData" @selection-change="handleSelectionChange" style="width: 100%">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column label="序号" type="index" width="70"></el-table-column>
          <el-table-column label="告警名称" prop="alarmName" show-overflow-tooltip></el-table-column>
          <el-table-column label="告警等级" prop="alarmLevel" :formatter="alarmLevelRender"
            show-overflow-tooltip></el-table-column>
          <el-table-column label="告警时间" prop="alarmTime" :formatter="alarmTimeRender"
            show-overflow-tooltip></el-table-column>
          <el-table-column label="告警类型" prop="alarmTypeLabel" show-overflow-tooltip></el-table-column>
          <el-table-column label="来源子系统" prop="subSystemLabel" show-overflow-tooltip></el-table-column>
          <el-table-column label="告警状态" prop="alarmState" :formatter="alarmStateRender"
            show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dealConfirm">误报处理</el-button>
        <el-button @click="dealCancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import controlLeft from "./control-left";
import alarmControl from "./alarmControl";

import { Dic } from "$utils";
import { api } from "../api";
import { mapMutations } from "vuex";
export default {
  components: {
    controlLeft,
    alarmControl,
  },
  filters: {
    alarmName(alarmType, item) {
      const value = Dic.findByValue("SENU004009", alarmType);
      return item.deviceName ? value + "_" + item.deviceName : value;
    },
  },
  props: {
    data: {
      type: Array,
      default: null,
    },
  },
  watch: {
    isShowList: {
      handler(val) {
        this.$emit("handleIsShow", val);
      },
      immediate: true,
    },
  },
  data() {
    return {
      alarmMergeFlag: "",
      tipLeft: "",
      tipTop: "",
      autoHeight: 110,
      lefTdata: [],
      visibleRightId: "",
      dataLoading: false,
      isAllSubSystem: false,
      isShowTypeCard: false,
      isShowSearch: true,
      isShowList: true,
      alarmList: "",
      boxScrollContainer: "",
      scrollView: "",
      subSystem: "",
      eventType: "",
      alarmTypes: [],
      rightClickList: [],
      isMerge: false, //数组列表显示状态，true-合并，false-分条
      systemAttrs: {},
      checkItem: {},
      modalClose: false,
      dealVisible: false,
      dealForm: {
        alarmType: [],
        alarmLevel: "",
        alarmTime: []
      },
      alarmLevelArr: Dic.find("SENU017"),
      cascaderOptions: [],
      allAlarmSystem: [],
      cascaderProps: {
        children: "children",
        label: "name",
        value: "id",
        checkStrictly: true,
        expandTrigger: "hover",
      },
      alarmSubSys: [],
      dealAlarmData: [],
      selectedItems: [],
      defaultStartTime: null,
      defaultEndTime: null
    };
  },
  created() {
    sessionStorage.removeItem("rightClickList");
  },
  computed: {
    typeLabel() {
      if (this.dealForm.alarmType) {
        return this.$refs.cascaderPanel && this.$refs.cascaderPanel.inputValue;
      } else {
        return "";
      }
    }
  },
  mounted() {
    this.scrollbar();
    this.isShowList = false;
    this.getAlarmTypeAndSubsystem()
  },
  methods: {
    ...mapMutations({
      addToAlarmList: "ADD_ALARM_TO_LIST",
      removeFromAlarmList: "REMOVE_ALARM_FROM_LIST",
    }),
    getAlarmTypeAndSubsystem() {
      const self = this;
      // 实时告警页面系统类型去除消防子系统和电器火灾
      this.$fetch('/bas/alarmSafeEvent/queryAlarmTypeAndSubsystem.json', {}).then((response) => {
        let subList = [];
        let alarmSys = []
        response.returnObj.forEach((item, index) => {
          if (item.id != "4" && item.id != "13" && item.id != "14") {
            subList.push(item);
            alarmSys.push(item.id)
          }
        })
        self.cascaderOptions = [...subList];
        self.allAlarmSystem = [...alarmSys]
      })
    },
    detailQuery() {
      let alarmStartTime = null
      let alarmEndTime = null
      if (this.dealForm.alarmTime && this.dealForm.alarmTime.length > 0) {
        alarmStartTime = this.dealForm.alarmTime[0];
        alarmEndTime = this.dealForm.alarmTime[1];
      }
      let params = {
        alarmStartTime: alarmStartTime,
        alarmEndTime: alarmEndTime,
        alarmLevel: this.dealForm.alarmLevel,
        alarmState: 1,
        // alarmTypeList: this.dealForm.alarmType,
        // subSystemList: this.alarmSubSys,
        alarmTypeList: this.dealForm.alarmType.length == 2 ? [this.dealForm.alarmType[1]] : [], //子系统类型
        subSystemList: this.dealForm.alarmType.length ? [this.dealForm.alarmType[0]] : this.allAlarmSystem,
        pageNum: 1,
        pageSize: 10000,
      };
      this.$fetch('/bas/alarmSafeEvent/queryResultsByPage.json', params).then((response) => {
        if (response.success) {
          this.dealAlarmData = response.returnObj ? response.returnObj.alarmList.list : []
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    handleSelectionChange(selectuion) {
      this.selectedItems = selectuion
    },
    alarmTimeRender(data) {
      const nowTime = new Date(data.alarmTime)
      const y = nowTime.getFullYear()
      let M = nowTime.getMonth() + 1
      M = M < 10 ? '0' + M : M
      let d = nowTime.getDate()
      d = d < 10 ? '0' + d : d
      let h = nowTime.getHours()
      h = h < 10 ? '0' + h : h
      let m = nowTime.getMinutes()
      m = m < 10 ? '0' + m : m
      let s = nowTime.getSeconds()
      s = s < 10 ? '0' + s : s
      const currentDate = y + '-' + M + '-' + d
      const currentTime = h + ':' + m + ':' + s
      return currentDate + ' ' + currentTime
    },
    timeRender(data) {
      const nowTime = new Date(data)
      const y = nowTime.getFullYear()
      let M = nowTime.getMonth() + 1
      M = M < 10 ? '0' + M : M
      let d = nowTime.getDate()
      d = d < 10 ? '0' + d : d
      let h = nowTime.getHours()
      h = h < 10 ? '0' + h : h
      let m = nowTime.getMinutes()
      m = m < 10 ? '0' + m : m
      let s = nowTime.getSeconds()
      s = s < 10 ? '0' + s : s
      const currentDate = y + '-' + M + '-' + d
      const currentTime = h + ':' + m + ':' + s
      return currentDate + ' ' + currentTime
    },
    alarmLevelRender(data) {
      const value = data.alarmLevel
      for (let i = 0; i < this.alarmLevelArr.length; i++) {
        if (this.alarmLevelArr[i].value == value) {
          return this.alarmLevelArr[i].label
        }
      }
    },
    alarmStateRender(data) {
      const value = data.alarmState
      if (value == 1) {
        return '待处理'
      } else if (value == 4) {
        return '已下发任务(处理中)'
      } else if (value == 10) {
        return '已下发任务(已完成)'
      }
    },
    detailReset() {
      this.alarmType = []
      this.dealForm.alarmType = []
      this.alarmLevel = ""
      this.dealForm.alarmTime = [this.timeRender(new Date().getTime() - 30 * 24 * 60 * 60 * 1000), this.timeRender(new Date().getTime())]
      this.detailQuery()
    },
    handleDealShow() {
      this.dealForm.alarmTime = [this.timeRender(new Date().getTime() - 30 * 24 * 60 * 60 * 1000), this.timeRender(new Date().getTime())]
      this.dealVisible = true
      this.detailQuery()
    },
    dealConfirm() {
      const self = this
      if (this.selectedItems.length === 0) {
        this.$message({
          type: "warning",
          duration: 2000,
          message: "请选择告警数据",
        });
        return;
      }
      let ids = this.selectedItems.map(item => { 
        return item.alarmId
      })
      this.$confirm("您确定要将选中的数据进行误报处理吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch('/bas/alarmSafeEvent/missBatchReport.json', {
          alarmIds: ids,
          alarmState: 3,
          processDesc: ''
        }).then((response) => {
          if (!response.success) {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "success",
              duration: 2000,
            });
            this.dealVisible = false
            this.$refs.left.handleQuery()
            this.removeFromAlarmList();
          }
        });
      })
    },
    dealCancel() {
      this.dealVisible = false
    },
    queryHandleStatus(value) {
      return Dic.findByValue("SENU068", Number(value));
    },
    showIcon(val) {
      if (val == "1001") {
        return "icon-lunan-zhoujieruqin";
      } else if (val == "1002") {
        return "icon-lunan-renyuangaojing";
      } else if (val == "1003") {
        return "icon-lunan-chelianggaojing";
      } else if (val == "1004") {
        return "icon-lunan-xiaofangtongdaozhanyong";
      } else if (val == "1005") {
        return "icon-lunan-chaosu";
      } else if (val == "1006") {
        return "icon-lunan-shoudonggaojing";
      } else if (val == "1007") {
        return "icon-lunan-shoudongqiujiubaojing";
      } else if (val == "10099") {
        return "icon-lunan-1";
      }
    },
    typeClick(val) {
      this.$emit("typeChange", val ? val.value : "");
    },
    // 消息推送处理
    checkMore() {
      if (this.autoHeight > 469) {
        this.autoHeight = 500;
      } else {
        if (this.lefTdata.length * 40 > this.autoHeight) {
          this.autoHeight += 60;
        }
      }
    },
    loadul() {
      //
    },
    alarmControlCall() {
      this.visibleRightId = "";
    },
    // 告警抑制
    alarmControl(val) {
      let params = {
        subSystem: val.subSystem,
        alarmType: val.alarmType,
        alarmDevId: val.alarmDevId,
      };
      this.$fetch(api.cms.queryAlarmIgnoreConfigInfo, params).then((res) => {
        if (res.success) {
          let data = res.returnObj;
          this.$refs.alarmControl.formDialog = {
            ignoreTime:
              data && data.beginTime ? [data.beginTime, data.endTime] : [],
            num: data ? data.alarmInterval : null,
          };
          this.$refs.alarmControl.alarmData = val;
          this.$refs.alarmControl.alarmType = val.alarmType;
          this.$refs.alarmControl.controlDialog = true;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    dealError(val) {
      let params = {
        alarmMergeFlag: val.alarmMergeFlag,
        alarmMergeCode: val.alarmMergeCode,
      };
      this.$emit("resetError", params);
    },
    handleLeftClick(val) {
      let isexpand = val.isExpand;
      this.visibleRightId = "";
      this.lefTdata = [];
      this.data.forEach((el) => {
        el.isExpand = false;
      });
      val.isExpand = !isexpand;
      this.autoHeight = 110;
      if (isexpand) {
        return;
      }
      let params = {
        pageNum: 1,
        pageSize: 100000,
        alarmLevel: this.$parent.queryParams.alarmLevel,
        alarmTypeList: this.$parent.queryParams.alarmTypeList,
        alarmMergeCode: val.alarmMergeCode,
        subSystemList: this.$parent.queryParams.subSystemList,
        alarmName: this.$parent.queryParams.deviceName,
        alarmStartTime: this.$parent.queryParams.alarmStartTime,
        alarmEndTime: this.$parent.queryParams.alarmEndTime,
      };
      this.$fetch(api.alarm.queryAlarmMergeAlarmList, params).then((res) => {
        if (res.success) {
          if (!res.returnObj || !res.returnObj.list) {
            this.$message("暂无合并信息");
            return;
          }
          this.lefTdata = res.returnObj.list || [];
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    isRightShowList(val) {
      let showList = JSON.parse(sessionStorage.getItem("rightClickList"));
      if (!showList || !showList.length) {
        return false;
      }
      let isTrue = showList.some((el) => {
        return el == val;
      });
      return isTrue;
    },
    // 告警合并-取消合并
    alarmMerge(val) {
      let url = "";
      let params = {
        fieldName: "alarmMergeFlag", //实时告警为alarmMergeFlag，消防告警为fireAlarmMergeFlag
      };
      if (val.alarmMergeFlag == 0) {
        // 合并
        url = api.bas.addAlarmFunctionConfig;
        params.fieldValue = "1";
      } else {
        url = api.bas.deleteAlarmFunctionConfig;
      }
      this.autoHeight = 110;
      this.visibleRightId = "";
      this.$fetch(url, params).then((res) => {
        if (res.success) {
          this.$message.success(res.msgContent);
          this.$emit("rightClick");
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    rightClick(val, e) {
      this.tipLeft = e.pageX > 300 ? 200 : e.offsetX;
      this.tipTop = e.offsetY + 15;
      this.visibleRightId = val.alarmId;
      this.checkItem = { ...val };
      val.isExpand = false;
    },
    alarmColor(level) {
      let className = "";
      if (level === 1) {
        className = "instancy";
      }
      if (level === 2) {
        className = "severity";
      }
      if (level === 3) {
        className = "general";
      }
      if (level === 4) {
        className = "common";
      }
      return className;
    },
    // 点击告警
    handleClick(item) {
      this.visibleRightId = "";
      this.checkItem = { ...item };
      this.$emit("handleClickAlarm", item);
    },
    // 列表滚动
    scrollbar() {
      this.alarmList = this.$refs.alarmList;
      this.boxScrollContainer = this.alarmList.$el.querySelector(
        ".el-scrollbar__wrap"
      );
      this.scrollView = this.boxScrollContainer.querySelector(
        ".el-scrollbar__view"
      );
      this.scrollFun = (e) => {
        if (
          e.srcElement.scrollTop + this.boxScrollContainer.clientHeight >=
          this.scrollView.clientHeight &&
          !this.dataLoading &&
          this.data.length % 30 === 0 &&
          this.data.length !== 0
        ) {
          this.$emit("nextPage");
        }
      };
      this.boxScrollContainer.addEventListener("scroll", this.scrollFun);
    },
    // 条件搜索
    handleSearch(val) {
      this.systemAttrs = Object.assign(this.systemAttrs, val);
      this.$emit("searchBtn", this.systemAttrs);
    },
    // 创建告警
    handleAddAlarm() {
      this.$emit("handleAddAlarm");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.alarm-list-page {
  position: absolute;
  top: 50px;
  left: 0;
  width: 350px;
  height: calc(100% - 50px) !important;
  z-index: 9;
  transition: left 0.3s;
}

.handle-alarm-button {
  position: absolute;
  left: 360px;
  top: 5px;
  z-index: 10;
}

.handle-deal-button {
  position: absolute;
  left: 360px;
  top: 50px;
  z-index: 10;
}

.closeList {
  left: -350px !important;
}

.ioc-alarm__list {
  height: calc(100% - 20px) !important;
}

.ioc-alarm__list__item li {
  // height: 100%;
  height: 90px !important;
}

.icon-transform {
  transform: rotate(180deg);
}

.expand-list {
  display: flex;
  height: 20px;
  line-height: 20px;
  align-items: center;
}

.list-detail {
  position: relative;
  width: 100%;
  font-size: 14px;
  border-radius: 10px;
  // @include set_theme_color(background-color, map-panel-content);
  background-color: cadetblue;
  padding: 10px;
  margin-top: 10px;
  z-index: 3001;

  .listTitle {
    // height: 24px;
    // line-height: 24px;
    margin: 5px 0;
    display: flex;
    // margin-bottom: 10px;
    flex-direction: row;
    justify-content: space-between;
    font-size: 12px;
    color: #fff;
  }

  .listUl {

    // height: 120px;
    // overflow: hidden;
    .listLi {
      display: flex;
      align-items: center;
      position: relative;
      width: 100%;
      height: 38px !important;
      color: #fff !important;

      // @include set_theme_color(background-color, dialog-content-bg-color);
      &:hover {
        @include set_theme_color(background-color, main-theme-color);
      }

      .listLi_time {
        font-size: 12px;
        padding-left: 10px;
      }

      .listLi_level {
        width: 50px;
        text-align: center;
        border-radius: 4px;
        position: absolute;
        right: 27px;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .listbt {
    text-align: center;
    margin-top: 5px;
  }
}

.rightTip {
  position: absolute;
  top: 33px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 32%;
  padding: 0px 0px;
  text-align: center;
  border-radius: 2px;
  color: #fff !important;
  background-color: #407aee;

  button {
    flex: 1;
    width: 100%;
    border: none;
    margin-left: 0;
    margin: 5px 0;
  }

  .closeTitle {
    position: absolute;
    right: 5px;
    top: 5px;
    font-size: 14px;
  }
}

.ioc-alarm__list__title {
  background-color: rgba(0, 0, 0, 0.5);
}

.noData {
  text-align: center;
  height: 80px;
}
</style>
